module.exports = __webpack_public_path__ + "assets/202509252035/img/screenshot-20241203-160349.19a342f2.png";